<template lang="html">
<vx-card title="Visit By Location">
    <div slot="actions" class="flex justify-center">
        <vs-button type="filled" class="text-center ml-2 min-w-100" @click="filterpopup = !filterpopup" v-if="isHideButtons">Filter</vs-button>
        <vs-button color="#10163a" type="filled" icon="save" class="w-auto ml-2 nowraptext" @click="addReportPopup=true" v-if="isHideButtons">Save Report</vs-button>
        <vs-button color="dark" type="filled" class="text-center ml-2 min-w-100" @click="goback">Back</vs-button>
    </div>
    <div slot="no-body" class="p-3 lg:p-4">
        <h2 class="text-black font-semibold mb-3 md:mb-5 text-xl"></h2>
        <VisitByLocationCountVue v-if="this.currentFilter" :propCurrentFilter="this.currentFilter" :propKey="key" />
        <ejs-grid :dataSource="VisitSignedInDeniedList" :allowGrouping='true' :groupSettings='groupOptions'>
            <e-columns>
                <e-column field='locationName' headerText='Location Name' width=120></e-column>
                <e-column field='signedInCount' headerText='Signed In Count' width=120></e-column>
                <e-column field='deniedCount' headerText='Denied Count' width=100></e-column>
            </e-columns>
        </ejs-grid>
        <!-- <template lang="html">
            <div class="theme_table table_nowrap">
                <vs-table search :data="VisitSignedInDeniedList" pagination maxItems="8" description :description-items="descriptionItems" description-title="Page" description-connector="of" description-body="Show entries">
                    <template slot="thead">
                        <vs-th sort-key="visitors">
                            Location Name
                        </vs-th>
                        <vs-th sort-key="purpose" class="text-center">
                            Signed In Count
                        </vs-th>
                        <vs-th sort-key="visiting" class="text-center">
                            Denied Count
                        </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{tr.locationName}}
                            </vs-td>
                            <vs-td class="text-center">
                                {{tr.signedInCount}}
                            </vs-td>
                            <vs-td class="text-center">
                                {{tr.deniedCount}}
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </template> -->
    </div>
    <vs-popup class="theme_modal filter_popup" title="Filter" :active.sync="filterpopup">
        <vs-row class="mt-2 mb-4 theme_form_control">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                <vs-select name="Range" v-model="currentFilter.rangeType" class="w-full" label="Range" placeholder="Select" @change="onChangeRange">
                    <vs-select-item value="" text="Select" />
                    <vs-select-item value="Today" text="Today" />
                    <vs-select-item value="ThisWeek" text="This Week" />
                    <vs-select-item value="ThisMonth" text="This Month" />
                    <vs-select-item value="LastMonth" text="Last Month" />
                    <vs-select-item value="Last6Months" text="Last 6 Months" />
                    <vs-select-item value="ThisYear" text="This Year" />
                    <vs-select-item value="LastYear" text="Last Year" />
                    <vs-select-item value="CustomRange" text="Custom Range" />
                </vs-select>
            </vs-col>
        </vs-row>
        <ejs-daterangepicker :placeholder="waterMark" cssClass="theme_daterangepicker" label="Date" v-model="currentFilter.date" format="dd/MM/yyyy" :enabled="isDaterangepicker" @change="handleDateRangeChange">
        </ejs-daterangepicker>
        <div class="text-center mt-5">
            <vs-button type="gradient" class="rounded-full" @click="loadVisitHistory()">Filter</vs-button>
            <vs-button type="gradient" class="rounded-full ml-2" @click="filterpopup = !filterpopup">Close</vs-button>
        </div>
    </vs-popup>
    <vs-popup class="theme_modal filter_popup" title="Lorem ipsum dolor sit amet" :active.sync="addReportPopup">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(saveUserReport)">
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                        <ValidationProvider class="w-full" :rules="{ required: true, max:100 }" v-slot="{ errors }" :custom-messages="customMessages">
                            <vs-input class="w-full theme_input" label-placeholder="Report Name" v-model="reportName" />
                            <span class="text-danger text-sm">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="text-center mt-5">
                    <vs-button type="gradient" class="rounded-full" @click="saveUserReport()">Save</vs-button>
                </div>
            </form>
        </ValidationObserver>
    </vs-popup>
</vx-card>
</template>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/report.scss";
</style>

<script>
import {
    userReportData
} from '@/store/api/userReport.js';
import {
    visitHistoryData
} from '@/store/api/visitHistory.js';
import {
    customMessages
} from "@/filters/validationmessage";
import '../../../../node_modules/@syncfusion/ej2-popups/styles/tailwind.css';
import moment from 'moment';
import VisitByLocationCountVue from './VisitByLocationCount.vue';
import Vue from 'vue';
import {
    GridPlugin,
    Group
} from '@syncfusion/ej2-vue-grids';
Vue.use(GridPlugin);

export default {
    data() {
        return {
            signedInCount: 0,
            deniedCount: 0,
            totalCount: 0,
            customMessages,
            addReportPopup: false,
            descriptionItems: [5, 8, 15],
            reportName: "",
            currentFilter: {},
            groupOptions: {
                columns: ['locationName']
            },
            VisitSignedInDeniedList: [],
            dateArray: [],
            waterMark: 'Selct a Range',
            dateFormat: "dd/MM/yyyy",
            key: 0,
            isDaterangepicker: false,
            filterpopup: false,
            isHideButtons: true,
        };
    },
    provide: {
        grid: [Group]
    },
    components: {
        VisitByLocationCountVue
    },
    async created() {
        if (this.$route.params.id) {
            this.isHideButtons = false;
            await this.getFilterData();
        } else {
            this.dateArray.push(new Date());
            this.dateArray.push(new Date());
            this.currentFilter = {
                date: this.dateArray,
                rangeType: "Today"
            }
        }
        await this.loadVisitHistory();
    },
    methods: {
        handleDateRangeChange(value) {
            var startDate = moment(String(moment(value.startDate, "YYYY-MM-DD"))).format('YYYY-MM-DD');
            var endDate = moment(String(moment(value.endDate, "YYYY-MM-DD"))).format('YYYY-MM-DD');
            this.currentFilter.date[0] = startDate
            this.currentFilter.date[1] = endDate
        },
        async onChangeRange() {
            this.isDaterangepicker = false;
            if (this.currentFilter.rangeType === 'CustomRange')
                this.isDaterangepicker = true;
        },
        async getFilterData() {
            var userReport = await userReportData.GetById(this.$route.params.id);
            if (userReport.payload !== null) {
                this.currentFilter = JSON.parse(userReport.payload);
            } else {
                this.currentFilter = {
                    date: this.dateArray
                }
            }
        },
        async loadVisitHistory() {
            this.key++;
            var payload = {
                startDate: this.currentFilter.date[0],
                endDate: this.currentFilter.date[1],
                rangeType: this.currentFilter.rangeType
            }
            this.VisitSignedInDeniedList = await visitHistoryData.searchVisitHistoryByLocation(payload);
            this.filterpopup = false;
        },
        async saveUserReport() {
            const success = await this.$refs.form.validate();
            if (!success) {
                return;
            }
            if (this.currentFilter.preset == "Custom Range") {
                this.$vs.notify({
                    title: "Error",
                    text: "Custom range not allowed.",
                    color: "danger",
                    position: "top-center"
                });
                return;
            }

            var payload = {
                ReportName: this.reportName,
                SystemReportName: 'VisitByLocation',
                payload: JSON.stringify(this.currentFilter)
            }
            let apiResult = await userReportData.saveUserReport(payload);
            if (!apiResult.succeeded) {
                this.$vs.notify({
                    title: "Error",
                    text: apiResult.message,
                    color: "danger",
                    position: "top-center"
                });
                return;
            }
            this.$vs.notify({
                title: "Success",
                text: "Record Save Successfully.",
                color: "success",
                position: "top-center"
            });
            this.reportName = '';
            this.addReportPopup = false;
        },

        goback() {
            this.$router.back();
        },
    }
}
</script>
  <style>
    .nowraptext .vs-button-text.vs-button--text {
      white-space: nowrap;
  }
  .theme_daterangepicker input{
    height:40px !important;
  }
  .theme_daterangepicker .e-input-group .e-clear-icon.e-clear-icon-hide, .theme_daterangepicker.e-input-group.e-control-wrapper .e-clear-icon.e-clear-icon-hide {
      display: inherit;
      opacity: 0;
  }
  </style>
